export var MOVETO_WIDTH = 264;
//# sourceMappingURL=constants.js.map